export default {
  baseStyle: {
    color: "gray.700",
    fontWeight: "normal",
    fontSize: "sm",
  },
};
